import React from 'react'
import LoginUi from './LoginUi'

const IndexLogin = () => {
  return (
    <div>
      <LoginUi/>
    </div>
  )
}

export default IndexLogin
